import Swal from "sweetalert2";

export const confirmationModal = async ({
  title,
  text,
  confirmText = "Delete",
  cancelText = "Cancel",
  isDanger = true,
}) => {
  return Swal.fire({
    title: title || "Are you sure?",
    text: text || "This action cannot be undone.",
    icon: "warning",
    showDenyButton: true,
    confirmButtonText: confirmText,
    denyButtonText: cancelText,
    buttonsStyling: false,

    customClass: {
      confirmButton: isDanger ? "btn btn-danger me-2" : "btn btn-primary me-2",
      denyButton: "btn btn-outline-secondary",
      popup: "card",
      title: "text-headings",
      htmlContainer: "text-body",
    },
  });
};
